import React, { useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import profile from "../img/profile.png";
import logo from "../img/logo-linear.png";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db, storage } from "../firebase/firebase";

export default function SideNav({ Content, selPage }) {
  const [mail, setMail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [userName, setUsername] = useState("Trainer");
  const [isSideNavClosed, setIsSideNavClosed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    //toggle sidebar
    let sidebar = document.querySelector(".sidebar");
    let closeBtn = document.getElementById("btn");

    const getSingleCacheData = async (cacheName, url) => {
      if (typeof caches === "undefined") return false;

      const cacheStorage = await caches.open(cacheName);
      const cachedResponse = await cacheStorage.match(url);

      // If no cache exists
      if (!cachedResponse || !cachedResponse.ok) {
        setIsSideNavClosed(false);
        setIsLoading(false);
      }

      cachedResponse.json().then((item) => {
        if (item == true) {
          sidebar.classList.toggle("open");
          menuBtnChange();
        }
        setIsSideNavClosed(item);
      });

      setIsLoading(false);
    };

    getSingleCacheData("isSideNavClosed", "/");

    //getmail
    const getMail = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          setMail(user.email);
          loadPermission(user.uid);
        } else {
          //todooooo
          window.location.replace("/");
        }
      });
    };
    getMail();

    function menuBtnChange() {
      if (sidebar.classList.contains("open")) {
        // isSideNavClosed = false;
        addDataIntoCache("isSideNavClosed", "/", false);

        closeBtn.classList.replace("bx-menu", "bx-menu-alt-right");
      } else {
        // isSideNavClosed = true;
        addDataIntoCache("isSideNavClosed", "/", true);

        closeBtn.classList.replace("bx-menu-alt-right", "bx-menu");
      }
    }

    closeBtn.addEventListener("click", () => {
      sidebar.classList.toggle("open");
      menuBtnChange();
    });

    const addDataIntoCache = (cacheName, url, response) => {
      // Converting our response into Actual Response form
      const data = new Response(JSON.stringify(response));

      if ("caches" in window) {
        // Opening given cache and putting our data into it
        caches.open(cacheName).then((cache) => {
          cache.put(url, data);
        });
      }
    };
  }, []);

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      setUsername(doc.data().username);
      if (doc.data().isAdmin) {
        setIsAdmin(true);
      } else {
      }
    });
  };

  function logout() {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        window.location.replace("/");
      })
      .catch((error) => {
        alert(error);
      });
  }

  return (
    <>
      <>
        <div className={"menu-sidebar " + (isLoading ? "display-none" : "")}>
          <div className={"sidebar open"}>
            <div className="logo-details">
              <img
                className="logo_name"
                src={logo}
                style={{ 
                  height: "35px",
                  filter: "brightness(0) invert(1)" 
                }}
                alt=""
              />
              <i className="bx bx-menu-alt-right" id="btn"></i>
            </div>
            <ul className="nav-list">
              {/* <li>
                <a
                  style={{
                    backgroundColor:
                      selPage == "dashboard" ? "#21252b" : "default",
                  }}
                  href="/home/dashboard"
                >
                  <i className="bx bx-grid-alt"></i>
                  <span className="links_name">Dashboard</span>
                </a>
                <span className="tooltip">Dashboard</span>
              </li> */}

              {/* <li>
              <a
                style={{
                  backgroundColor:
                    selPage == "statistics" ? "#21252b" : "default",
                }}
                href="/home/statistics"
              >
                <i className="bx bx-pie-chart-alt-2"></i>
                <span className="links_name">Statistiken</span>
              </a>
              <span className="tooltip">Statistiken</span>
            </li> */}
              <li>
                <a
                  style={{
                    backgroundColor: selPage == "plans" ? "#21252b" : "default",
                  }}
                  href="/home/plans"
                >
                  <i className="bx bx-folder"></i>
                  <span className="links_name">Trainingspläne</span>
                </a>
                <span className="tooltip">Trainingspläne</span>
              </li>
              <li>
                <a
                  style={{
                    backgroundColor:
                      selPage == "sessions" ? "#21252b" : "default",
                  }}
                  href="/home/sessions"
                >
                  <i className="bx bx-spreadsheet"></i>
                  <span className="links_name">Trainingseinheiten</span>
                </a>
                <span className="tooltip">Trainingseinheiten</span>
              </li>
              <li>
                <a
                  style={{
                    backgroundColor:
                      selPage == "workouts" ? "#21252b" : "default",
                  }}
                  href="/home/workouts"
                >
                  <i className="bx bx-file"></i>
                  <span className="links_name">Übungen</span>
                </a>
                <span className="tooltip">Übungen</span>
              </li>
              <li>
                <a
                  style={{
                    backgroundColor: selPage == "users" ? "#21252b" : "default",
                  }}
                  href="/home/users"
                >
                  <i className="bx bx-user"></i>
                  <span className="links_name">User</span>
                </a>
                <span className="tooltip">User</span>
              </li>
              {isAdmin && (
                <li>
                  <a
                    style={{
                      backgroundColor:
                        selPage == "settings" ? "#21252b" : "default",
                    }}
                    href="/home/settings"
                  >
                    <i className="bx bx-cog"></i>
                    <span className="links_name">Einstellungen</span>
                  </a>
                  <span className="tooltip">Einstellungen</span>
                </li>
              )}
              <li className="profile">
                <div className="profile-details">
                  <img
                    style={{
                      width: 30,
                      height: 30,
                      marginTop: 5,
                      marginBottom: 5,
                    }}
                    src={profile}
                    alt=""
                  />
                  <div className="name_job">
                    <div
                      style={{
                        fontSize: 10,
                      }}
                      className="name user-name"
                    >
                      {mail == "" ? "-" : mail}
                    </div>
                    <div className="job">{userName}</div>
                  </div>
                </div>
                <button
                  style={{
                    cursor: "pointer",
                    backgroundColor: "transparent",
                    borderColor: "transparent",
                    color: "#fff",
                  }}
                  onClick={logout}
                  className="btn-logout"
                >
                  <i className="bx bx-log-out" id="log_out"></i>
                </button>
              </li>
            </ul>
          </div>

          {Content()}

          <footer className="foot">
            <div className="container">
              <ul className="flex-row">
                <li>
                  <button
                    style={{
                      cursor: "pointer",
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                      color: "#fff",
                    }}
                    onClick={logout}
                    className="btn-logout-footer"
                  >
                    Abmelden
                  </button>
                </li>
              </ul>
              <ul className="flex-row">
                <li>
                  <a href="https://play.google.com/store/apps/details?id=com.trainingsapp.trainingsapp" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-google-play">
                      <FontAwesomeIcon
                        icon={icon({ name: "google-play", style: "brands" })}
                      />
                    </i>
                  </a>
                </li>
                <li>
                  <a href="https://apps.apple.com/at/app/elev8ion/id1645771356" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-app-store-ios">
                      <FontAwesomeIcon
                        icon={icon({ name: "app-store-ios", style: "brands" })}
                      />
                    </i>
                  </a>
                </li>
              </ul>
              <p>{"© 2025 ELEV8ION"}</p>
            </div>
          </footer>
        </div>
      </>
    </>
  );
}
